module.exports = __webpack_public_path__ + "img/住宿.1cea6fcf.png";